
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import EnrollmentAppliedDiscounts from "./components/EnrollmentAppliedDiscountsContent.vue";

export default defineComponent({
  name: "IEnrollmentAppliedDiscountsPage",
  components: {
    BreadCrumb,
    EnrollmentAppliedDiscounts,
  },
});
